/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getEditModelResource } from '@jira/router-resources__classic-projects/src/getEditModelResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getQueuesResources,
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
	getQueueViewConfigResource,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskQueuesViewsConfigRoute } from '@jira/router-routes__servicedesk-queues-routes/src/servicedeskQueuesViewsConfigRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { componentWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { serviceDeskQueuesConfigPageEntryPoint } from './ui/queues-config-page-entry-point/index.tsx';
import {
	ServicedeskQueuesViewsConfig,
	LazyServicedeskQueuesViewsConfig,
} from './ui/views-config/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

// TODO: Remove the `forPaint` and `component` properties when jsm_views_inside_queues_-_main_flag is cleaned up
export const servicedeskQueuesViewsConfigRouteEntry: Route = createEntry(
	servicedeskQueuesViewsConfigRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getQueuesResources(),
			getConsolidationStateResource(),
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			...getQueueViewConfigResource(),
			getEditModelResource(),
			projectContextResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyServicedeskQueuesViewsConfig],
		ufoName: 'service-management.views.config',

		// eslint-disable-next-line no-restricted-syntax
		component: componentWithCondition(
			() => fg('jsm_views_inside_queues_-_main_flag'),
			ServicedeskQueuesViewsConfig,
			ErrorPagesNotFound,
		),

		pageId: ({ query, match }) =>
			fg('jsm_views_inside_queues_-_main_flag')
				? `spa-apps/servicedesk/queues/views-config/${query.config}`
				: `spa-apps/servicedesk/queues/edit/${(match.params && match.params.queueId) || ''}`,

		entryPoint() {
			return fg('jsm_views_inside_queues_-_main_flag')
				? serviceDeskQueuesConfigPageEntryPoint
				: undefined;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
